// Mock data para Box7go Estética e Lava Jato

export const siteConfig = {
  name: "Box7go Estética e Lava Jato",
  tagline: "Tempo de Pit Stop. Brilho de Pódio.",
  phone: "5562982416008",
  whatsappLink: "https://wa.me/5562982416008",
  instagram: "https://www.instagram.com/box7.go/",
  googleMaps: "https://maps.app.goo.gl/u4Shanyp2XZS3BHZ8",
  address: {
    street: "Jardim Bela Vista",
    city: "Goiânia",
    state: "GO",
    cep: "74000-000"
  },
  logo: "https://customer-assets.emergentagent.com/job_6f0edc25-344f-42c2-bad9-83f2f1db633b/artifacts/9w2b2owp_Box%207%20estetica%20e%20lava%20jato%20-%20Logo.png"
};

export const heroImages = [
  "https://images.unsplash.com/photo-1761312834150-4beefff097a7",
  "https://images.unsplash.com/photo-1731986799546-d18eb1110df4",
  "https://images.unsplash.com/photo-1750492786518-ab308a72603a",
  "https://images.pexels.com/photos/6873121/pexels-photo-6873121.jpeg"
];

export const galleryImages = [
  "https://images.unsplash.com/photo-1605437241278-c1806d14a4d9",
  "https://images.unsplash.com/photo-1620584899131-a5ff5f8fbb03",
  "https://images.pexels.com/photos/29504461/pexels-photo-29504461.jpeg",
  "https://images.unsplash.com/photo-1708805282706-f44730b7e527",
  "https://images.unsplash.com/photo-1708805282676-0c15476eb8a2",
  "https://images.unsplash.com/photo-1708805282683-50a060eba80f"
];

export const services = [
  {
    id: "lavagem-simples",
    slug: "lavagem-simples",
    name: "Lavagem Simples",
    shortDesc: "Limpeza externa rápida e eficiente",
    description: "Lavagem externa completa do veículo com produtos de qualidade profissional. Ideal para manutenção regular e limpeza rápida.",
    features: [
      "Lavagem externa completa",
      "Secagem detalhada",
      "Limpeza de rodas",
      "Finalização com brilho"
    ],
    duration: "30 minutos",
    image: "https://customer-assets.emergentagent.com/job_preview-box7go/artifacts/kdovdr33_Lavagem%20simples%20Goiania%20-%20Box%207%20estetica%20e%20lava%20jato.jpg"
  },
  {
    id: "lavagem-completa",
    slug: "lavagem-completa",
    name: "Lavagem Completa",
    shortDesc: "Limpeza interna e externa com atenção aos detalhes",
    description: "Serviço completo incluindo lavagem externa e limpeza interna detalhada. Seu veículo recebe cuidado total dentro e fora.",
    features: [
      "Lavagem externa premium",
      "Aspiração completa do interior",
      "Limpeza de painéis e console",
      "Limpeza de vidros internos e externos",
      "Hidratação de pneus",
      "Perfumização"
    ],
    duration: "1 hora",
    image: "https://customer-assets.emergentagent.com/job_preview-box7go/artifacts/iirxbpv3_lava%20jato%20lavagem%20Completa%20estetica%20automotiva%20box%207.jpg"
  },
  {
    id: "lavagem-detalhada",
    slug: "lavagem-detalhada",
    name: "Lavagem Detalhada",
    shortDesc: "Atenção extrema a cada detalhe do veículo",
    description: "Lavagem profunda com foco total nos detalhes. Tratamento especial para garantir acabamento impecável.",
    features: [
      "Tudo da lavagem completa",
      "Limpeza profunda de estofados",
      "Polimento básico",
      "Tratamento de plásticos",
      "Limpeza de porta-malas",
      "Proteção de borrachas"
    ],
    duration: "2 horas",
    image: "https://customer-assets.emergentagent.com/job_preview-box7go/artifacts/vaf88zqb_Restaura%C3%A7%C3%A3o%20interior%20higieniza%C3%A7%C3%A3o%20couro%20revitaliza%C3%A7%C3%A3o%20-%20goiania%20-%20lava%20jato%20box%207.jpeg"
  },
  {
    id: "lavagem-detalhada-nivel-1",
    slug: "lavagem-detalhada-nivel-1",
    name: "Lavagem Detalhada Nível 1",
    shortDesc: "Primeiro nível de detalhamento profissional",
    description: "Introdução ao detalhamento premium com produtos especializados e técnicas avançadas de limpeza.",
    features: [
      "Todos os benefícios da lavagem detalhada",
      "Aplicação de cera sintética",
      "Polimento leve de pintura",
      "Limpeza de motor (externa)",
      "Tratamento de couro (se aplicável)"
    ],
    duration: "3 horas",
    image: "https://customer-assets.emergentagent.com/job_preview-box7go/artifacts/qg6127tg_Sevi%C3%A7os%20lava%20jato%20estetica%20automotiva%20goiania%20box%207.jpg"
  },
  {
    id: "lavagem-detalhada-nivel-2",
    slug: "lavagem-detalhada-nivel-2",
    name: "Lavagem Detalhada Nível 2",
    shortDesc: "Detalhamento avançado para brilho duradouro",
    description: "Serviço premium com polimento de alta performance e proteção prolongada da pintura.",
    features: [
      "Tudo do Nível 1",
      "Polimento de correção de pintura",
      "Aplicação de selante de pintura",
      "Vitrificação de vidros",
      "Restauração de faróis",
      "Proteção de rodas"
    ],
    duration: "4-5 horas",
    image: "https://images.unsplash.com/photo-1708805282676-0c15476eb8a2"
  },
  {
    id: "lavagem-detalhada-nivel-3",
    slug: "lavagem-detalhada-nivel-3",
    name: "Lavagem Detalhada Nível 3",
    shortDesc: "Máximo em estética automotiva premium",
    description: "O ápice do detalhamento automotivo. Tratamento completo com produtos de linha profissional e acabamento que mantém o brilho por até 30 dias.",
    features: [
      "Todos os serviços do Nível 2",
      "Polimento de alta definição",
      "Cristalização de pintura",
      "Proteção cerâmica light",
      "Limpeza técnica completa de motor",
      "Ozonização do ar-condicionado",
      "Revitalização total de plásticos e borrachas"
    ],
    duration: "6-8 horas",
    image: "https://customer-assets.emergentagent.com/job_preview-box7go/artifacts/aa7v4onm_lava%20jato%20lavagem%20detalhada%20goiania%20nivel%203%20estetica%20automotiva%20box%207.jpg"
  },
  {
    id: "estetica-automotiva",
    slug: "estetica-automotiva",
    name: "Estética Automotiva",
    shortDesc: "Serviços especializados de estética completa",
    description: "Pacotes personalizados de estética automotiva com foco em correção de pintura, proteção e restauração.",
    features: [
      "Polimento e cristalização",
      "Vitrificação de pintura",
      "Restauração de faróis",
      "Higienização de ar-condicionado",
      "Impermeabilização de estofados",
      "Restauração de couro"
    ],
    duration: "Sob consulta",
    image: "https://images.unsplash.com/photo-1605437241278-c1806d14a4d9"
  }
];

export const differentials = [
  {
    icon: "Shield",
    title: "Galpão Coberto",
    description: "Seu veículo protegido do sol e intempéries durante todo o serviço"
  },
  {
    icon: "Sparkles",
    title: "Produtos Premium",
    description: "Utilizamos apenas produtos automotivos de alta eficiência e qualidade profissional"
  },
  {
    icon: "Users",
    title: "Equipe Especializada",
    description: "Profissionais extremamente capacitados e treinados em técnicas modernas"
  },
  {
    icon: "Clock",
    title: "Agilidade e Qualidade",
    description: "Do pit stop à perfeição: rapidez sem comprometer o resultado impecável"
  },
  {
    icon: "MapPin",
    title: "Localização Estratégica",
    description: "Fácil acesso em Goiânia e Aparecida de Goiânia"
  },
  {
    icon: "Heart",
    title: "Ambiente Acolhedor",
    description: "Espaço confortável para você aguardar enquanto cuidamos do seu veículo"
  }
];

export const neighborhoods = [
  "Jardim Bela Vista",
  "Parque das Laranjeiras",
  "Jardim da Luz",
  "Parque Acalanto",
  "Vila Alzira",
  "Conjunto Fabiana",
  "Jardins Paris",
  "Sítios Santa Luzia",
  "Alto da Glória",
  "Setor Jardim Goiás",
  "Setor Pedro Ludovico",
  "Parque Atheneu",
  "Chácara do Governador",
  "Jardim Mariliza",
  "Parque Trindade",
  "Jardim Olímpico",
  "Jardins Milão",
  "Vila Redenção"
];

export const testimonials = [
  {
    name: "Carlos Alberto Silva",
    rating: 5,
    text: "Excelente serviço! Meu carro ficou impecável, brilhando como novo. A equipe é muito profissional e atenciosa. Recomendo!",
    location: "Jardim Bela Vista"
  },
  {
    name: "Mariana Costa",
    rating: 5,
    text: "Melhor lava jato da região! O detalhamento nível 3 superou todas as minhas expectativas. Valeu cada centavo.",
    location: "Aparecida de Goiânia"
  },
  {
    name: "Roberto Fernandes",
    rating: 5,
    text: "Atendimento excepcional e qualidade incomparável. O galpão coberto faz toda diferença. Meu carro está protegido enquanto é lavado.",
    location: "Parque das Laranjeiras"
  },
  {
    name: "Juliana Oliveira",
    rating: 5,
    text: "Simplesmente perfeito! A estética automotiva deixou meu carro com aspecto de zero km. Equipe nota 10!",
    location: "Setor Jardim Goiás"
  },
  {
    name: "André Luiz Santos",
    rating: 5,
    text: "Profissionalismo e qualidade em cada detalhe. O tempo de pit stop com brilho de pódio é real! Voltarei sempre.",
    location: "Vila Alzira"
  },
  {
    name: "Patrícia Mendes",
    rating: 5,
    text: "Fantástico! A lavagem completa é muito bem feita, produtos excelentes e preço justo. Indico de olhos fechados!",
    location: "Jardim da Luz"
  }
];

export const faqs = [
  {
    question: "Quanto tempo demora cada serviço?",
    answer: "Os tempos variam: Lavagem Simples (30 min), Completa (1h), Detalhada (2h), Nível 1 (3h), Nível 2 (4-5h) e Nível 3 (6-8h). Entre em contato para agendamento e confirmar disponibilidade."
  },
  {
    question: "Preciso agendar ou aceita por ordem de chegada?",
    answer: "Recomendamos agendamento pelo WhatsApp para garantir seu horário, mas também atendemos por ordem de chegada conforme disponibilidade."
  },
  {
    question: "Quais formas de pagamento são aceitas?",
    answer: "Aceitamos dinheiro, PIX, cartões de débito e crédito. Entre em contato pelo WhatsApp para confirmar valores e condições."
  },
  {
    question: "O que diferencia a Box7go de outros lava jatos?",
    answer: "Trabalhamos em galpão coberto protegendo seu veículo, usamos produtos premium de alta eficiência, nossa equipe é extremamente capacitada e oferecemos desde serviço rápido até detalhamento de nível profissional com brilho duradouro."
  },
  {
    question: "Vocês atendem todos os tipos de veículos?",
    answer: "Sim! Atendemos carros de passeio, SUVs, picapes e veículos utilitários. Consulte-nos para serviços em veículos especiais."
  },
  {
    question: "O brilho do detalhamento nível 3 dura mesmo 30 dias?",
    answer: "Sim! Com os produtos profissionais e técnicas de cristalização utilizados, o acabamento premium mantém o brilho intenso por até 30 dias, independente da cor do veículo."
  },
  {
    question: "Vocês fazem apenas lavagem ou também restauração?",
    answer: "Fazemos ambos! Além de lavagens em todos os níveis, oferecemos serviços completos de estética automotiva incluindo polimento, vitrificação, restauração de faróis, impermeabilização e muito mais."
  },
  {
    question: "Onde fica a Box7go?",
    answer: "Estamos localizados em Goiânia, atendendo toda região incluindo Aparecida de Goiânia. Clique no botão 'Como Chegar' para ver a localização exata no Google Maps."
  }
];

export const cities = [
  { name: "Goiânia", slug: "goiania" },
  { name: "Aparecida de Goiânia", slug: "aparecida-de-goiania" }
];

export const beforeAfterGallery = [
  {
    title: "Detalhamento Completo",
    before: "https://customer-assets.emergentagent.com/job_preview-box7go/artifacts/ufkw1jj0_Antes%20bl1%20-%20Lava%20jato%20goiania%20box%207.jpg",
    after: "https://customer-assets.emergentagent.com/job_preview-box7go/artifacts/v0lgk5tu_Depois%20bl1%20-%20Lava%20jato%20goiania%20box%207.jpg"
  },
  {
    title: "Polimento e Cristalização",
    before: "https://customer-assets.emergentagent.com/job_preview-box7go/artifacts/knvy12ee_Antes%20b2%20lavajato%20polimento%20goiania%20-%20Box%207%20estetica%20e%20lava%20jato.jpg",
    after: "https://customer-assets.emergentagent.com/job_preview-box7go/artifacts/0ir586ei_Depois%20b2%20lavajato%20polimento%20goiania%20-%20Box%207%20estetica%20e%20lava%20jato.jpg"
  },
  {
    title: "Restauração Interior",
    before: "https://customer-assets.emergentagent.com/job_preview-box7go/artifacts/9ssk9dcd_depois%20Restaura%C3%A7%C3%A3o%20interior%20higieniza%C3%A7%C3%A3o%20couro%20revitaliza%C3%A7%C3%A3o%20-%20goiania%20-%20lava%20jato%20box%207.png",
    after: "https://customer-assets.emergentagent.com/job_preview-box7go/artifacts/cfazmzbf_Restaura%C3%A7%C3%A3o%20interior%20higieniza%C3%A7%C3%A3o%20couro%20revitaliza%C3%A7%C3%A3o%20-%20goiania%20-%20lava%20jato%20box%207.jpg"
  }
];
